// ⚠️ TEMPORARY — the support-only portal, served from its own host.
//
// BPCL reach the same deployment through a second hostname, served by its own ECS service behind a
// load-balancer host rule. Both hosts run the SAME build and talk to the same backend; only the
// chrome differs, so that a support user lands on the ticket list and sees nothing else.
//
// ⚠️ THIS IS A UI SWITCH AND NOTHING MORE. The portal itself is still resolved server-side — the
// backend reads `EnableMultiPortal=false` on that task and returns the single portal document
// regardless of which hostname the browser used — so `portalData` is identical on both hosts.
// Never derive a portal, a tenant or a ticket scope from this: `portal.frontendUrl` remains the
// canonical hostname (`digikrpetchem.cube.ms`), and the SLA export and the on-premise relay both
// key off it.
//
// To remove: delete this file and its four call sites (Header, getHomePageUrl, NotificationPage,
// NotificationsGridView).

/**
 * The full hostname, not a `support.` prefix — a prefix test would also capture any other
 * `support.*` host that is ever pointed at this build, and silently strip its navigation.
 */
export const SUPPORT_PORTAL_HOST = "support.digikrpetchem.cube.ms";

/** Whether this browser reached the app through the support-only host. */
export const isSupportPortalHost = (): boolean => globalThis.location?.hostname === SUPPORT_PORTAL_HOST;
